import { jsx as a, jsxs as k, Fragment as Te } from "react/jsx-runtime";
import { R as rt, V as lt, S as st, T as ct } from "../../../../index-BCwqkKr8.js";
import * as o from "react";
import * as Ae from "react-dom";
import { c as Ne } from "../../../../index-rKs9bXHr.js";
import { u as Re, c as N, a as j } from "../../../../index-D7uzFyzw.js";
import { u as at, c as it } from "../../../../index-BsL1G1kw.js";
import { c as dt, u as B, P as A, a as ut } from "../../../../index-Bud8rdvZ.js";
import { P as pt, D as ft } from "../../../../index-Bbj5DEcJ.js";
import { h as mt, u as ht, R as vt, F as gt } from "../../../../index-yIniEU8A.js";
import { u as be } from "../../../../index-B6DkbY8I.js";
import { c as Oe, R as St, A as wt, C as _t, a as Ct } from "../../../../index-CQMsoup1.js";
import { u as xt } from "../../../../index-0ioNhtNM.js";
import { u as yt } from "../../../../index-BZPx6jYI.js";
import { V as It } from "../../../../index-BMQ7iO4X.js";
import { c as ie } from "../../../../clsx-OuTLNxxd.js";
import "../../../../button.types-BqgkEc5r.js";
import "../../button/iconButton/iconButton.js";
import { I as Ee } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import "../../tag/tag.js";
import "../../carousel/carousel.js";
import "../input/input.js";
import "../checkbox/checkbox.js";
import "../../../../phoneNumber-5ohMfWd7.js";
import "../dateRangePicker/dateRangePicker.js";
import "../../toast/toast.context.js";
import "../../../../map-DjiAXeob.js";
import { Flex as Tt } from "../../../layout/flex/flex.js";
var bt = [" ", "Enter", "ArrowUp", "ArrowDown"], Pt = [" ", "Enter"], ee = "Select", [ue, pe, Nt] = it(ee), [ne, Do] = dt(ee, [
  Nt,
  Oe
]), fe = Oe(), [Rt, q] = ne(ee), [Et, Mt] = ne(ee), De = (r) => {
  const {
    __scopeSelect: c,
    children: e,
    open: i,
    defaultOpen: l,
    onOpenChange: u,
    value: t,
    defaultValue: n,
    onValueChange: s,
    dir: p,
    name: v,
    autoComplete: S,
    disabled: b,
    required: w,
    form: I
  } = r, d = fe(c), [h, _] = o.useState(null), [m, g] = o.useState(null), [G, O] = o.useState(!1), re = at(p), [R, L] = Re({
    prop: i,
    defaultProp: l ?? !1,
    onChange: u,
    caller: ee
  }), [z, Z] = Re({
    prop: t,
    defaultProp: n,
    onChange: s,
    caller: ee
  }), H = o.useRef(null), F = h ? I || !!h.closest("form") : !0, [$, W] = o.useState(/* @__PURE__ */ new Set()), U = Array.from($).map((E) => E.props.value).join(";");
  return /* @__PURE__ */ a(St, { ...d, children: /* @__PURE__ */ k(
    Rt,
    {
      required: w,
      scope: c,
      trigger: h,
      onTriggerChange: _,
      valueNode: m,
      onValueNodeChange: g,
      valueNodeHasChildren: G,
      onValueNodeHasChildrenChange: O,
      contentId: be(),
      value: z,
      onValueChange: Z,
      open: R,
      onOpenChange: L,
      dir: re,
      triggerPointerDownPosRef: H,
      disabled: b,
      children: [
        /* @__PURE__ */ a(ue.Provider, { scope: c, children: /* @__PURE__ */ a(
          Et,
          {
            scope: r.__scopeSelect,
            onNativeOptionAdd: o.useCallback((E) => {
              W((V) => new Set(V).add(E));
            }, []),
            onNativeOptionRemove: o.useCallback((E) => {
              W((V) => {
                const K = new Set(V);
                return K.delete(E), K;
              });
            }, []),
            children: e
          }
        ) }),
        F ? /* @__PURE__ */ k(
          et,
          {
            "aria-hidden": !0,
            required: w,
            tabIndex: -1,
            name: v,
            autoComplete: S,
            value: z,
            onChange: (E) => Z(E.target.value),
            disabled: b,
            form: I,
            children: [
              z === void 0 ? /* @__PURE__ */ a("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          U
        ) : null
      ]
    }
  ) });
};
De.displayName = ee;
var Le = "SelectTrigger", Ve = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, disabled: i = !1, ...l } = r, u = fe(e), t = q(Le, e), n = t.disabled || i, s = B(c, t.onTriggerChange), p = pe(e), v = o.useRef("touch"), [S, b, w] = ot((d) => {
      const h = p().filter((g) => !g.disabled), _ = h.find((g) => g.value === t.value), m = nt(h, d, _);
      m !== void 0 && t.onValueChange(m.value);
    }), I = (d) => {
      n || (t.onOpenChange(!0), w()), d && (t.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ a(wt, { asChild: !0, ...u, children: /* @__PURE__ */ a(
      A.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": t.contentId,
        "aria-expanded": t.open,
        "aria-required": t.required,
        "aria-autocomplete": "none",
        dir: t.dir,
        "data-state": t.open ? "open" : "closed",
        disabled: n,
        "data-disabled": n ? "" : void 0,
        "data-placeholder": tt(t.value) ? "" : void 0,
        ...l,
        ref: s,
        onClick: N(l.onClick, (d) => {
          d.currentTarget.focus(), v.current !== "mouse" && I(d);
        }),
        onPointerDown: N(l.onPointerDown, (d) => {
          v.current = d.pointerType;
          const h = d.target;
          h.hasPointerCapture(d.pointerId) && h.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (I(d), d.preventDefault());
        }),
        onKeyDown: N(l.onKeyDown, (d) => {
          const h = S.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && b(d.key), !(h && d.key === " ") && bt.includes(d.key) && (I(), d.preventDefault());
        })
      }
    ) });
  }
);
Ve.displayName = Le;
var Be = "SelectValue", He = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, className: i, style: l, children: u, placeholder: t = "", ...n } = r, s = q(Be, e), { onValueNodeHasChildrenChange: p } = s, v = u !== void 0, S = B(c, s.onValueNodeChange);
    return j(() => {
      p(v);
    }, [p, v]), /* @__PURE__ */ a(
      A.span,
      {
        ...n,
        ref: S,
        style: { pointerEvents: "none" },
        children: tt(s.value) ? /* @__PURE__ */ a(Te, { children: t }) : u
      }
    );
  }
);
He.displayName = Be;
var kt = "SelectIcon", Fe = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, children: i, ...l } = r;
    return /* @__PURE__ */ a(A.span, { "aria-hidden": !0, ...l, ref: c, children: i || "▼" });
  }
);
Fe.displayName = kt;
var At = "SelectPortal", We = (r) => /* @__PURE__ */ a(pt, { asChild: !0, ...r });
We.displayName = At;
var te = "SelectContent", Ue = o.forwardRef(
  (r, c) => {
    const e = q(te, r.__scopeSelect), [i, l] = o.useState();
    if (j(() => {
      l(new DocumentFragment());
    }, []), !e.open) {
      const u = i;
      return u ? Ae.createPortal(
        /* @__PURE__ */ a(Ke, { scope: r.__scopeSelect, children: /* @__PURE__ */ a(ue.Slot, { scope: r.__scopeSelect, children: /* @__PURE__ */ a("div", { children: r.children }) }) }),
        u
      ) : null;
    }
    return /* @__PURE__ */ a(Ge, { ...r, ref: c });
  }
);
Ue.displayName = te;
var D = 10, [Ke, X] = ne(te), Ot = "SelectContentImpl", Dt = ut("SelectContent.RemoveScroll"), Ge = o.forwardRef(
  (r, c) => {
    const {
      __scopeSelect: e,
      position: i = "item-aligned",
      onCloseAutoFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: t,
      //
      // PopperContent props
      side: n,
      sideOffset: s,
      align: p,
      alignOffset: v,
      arrowPadding: S,
      collisionBoundary: b,
      collisionPadding: w,
      sticky: I,
      hideWhenDetached: d,
      avoidCollisions: h,
      //
      ..._
    } = r, m = q(te, e), [g, G] = o.useState(null), [O, re] = o.useState(null), R = B(c, (f) => G(f)), [L, z] = o.useState(null), [Z, H] = o.useState(
      null
    ), F = pe(e), [$, W] = o.useState(!1), U = o.useRef(!1);
    o.useEffect(() => {
      if (g) return mt(g);
    }, [g]), ht();
    const E = o.useCallback(
      (f) => {
        const [T, ...M] = F().map((P) => P.ref.current), [C] = M.slice(-1), x = document.activeElement;
        for (const P of f)
          if (P === x || (P?.scrollIntoView({ block: "nearest" }), P === T && O && (O.scrollTop = 0), P === C && O && (O.scrollTop = O.scrollHeight), P?.focus(), document.activeElement !== x)) return;
      },
      [F, O]
    ), V = o.useCallback(
      () => E([L, g]),
      [E, L, g]
    );
    o.useEffect(() => {
      $ && V();
    }, [$, V]);
    const { onOpenChange: K, triggerPointerDownPosRef: Y } = m;
    o.useEffect(() => {
      if (g) {
        let f = { x: 0, y: 0 };
        const T = (C) => {
          f = {
            x: Math.abs(Math.round(C.pageX) - (Y.current?.x ?? 0)),
            y: Math.abs(Math.round(C.pageY) - (Y.current?.y ?? 0))
          };
        }, M = (C) => {
          f.x <= 10 && f.y <= 10 ? C.preventDefault() : g.contains(C.target) || K(!1), document.removeEventListener("pointermove", T), Y.current = null;
        };
        return Y.current !== null && (document.addEventListener("pointermove", T), document.addEventListener("pointerup", M, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", T), document.removeEventListener("pointerup", M, { capture: !0 });
        };
      }
    }, [g, K, Y]), o.useEffect(() => {
      const f = () => K(!1);
      return window.addEventListener("blur", f), window.addEventListener("resize", f), () => {
        window.removeEventListener("blur", f), window.removeEventListener("resize", f);
      };
    }, [K]);
    const [me, ce] = ot((f) => {
      const T = F().filter((x) => !x.disabled), M = T.find((x) => x.ref.current === document.activeElement), C = nt(T, f, M);
      C && setTimeout(() => C.ref.current.focus());
    }), he = o.useCallback(
      (f, T, M) => {
        const C = !U.current && !M;
        (m.value !== void 0 && m.value === T || C) && (z(f), C && (U.current = !0));
      },
      [m.value]
    ), ve = o.useCallback(() => g?.focus(), [g]), oe = o.useCallback(
      (f, T, M) => {
        const C = !U.current && !M;
        (m.value !== void 0 && m.value === T || C) && H(f);
      },
      [m.value]
    ), ae = i === "popper" ? _e : ze, le = ae === _e ? {
      side: n,
      sideOffset: s,
      align: p,
      alignOffset: v,
      arrowPadding: S,
      collisionBoundary: b,
      collisionPadding: w,
      sticky: I,
      hideWhenDetached: d,
      avoidCollisions: h
    } : {};
    return /* @__PURE__ */ a(
      Ke,
      {
        scope: e,
        content: g,
        viewport: O,
        onViewportChange: re,
        itemRefCallback: he,
        selectedItem: L,
        onItemLeave: ve,
        itemTextRefCallback: oe,
        focusSelectedItem: V,
        selectedItemText: Z,
        position: i,
        isPositioned: $,
        searchRef: me,
        children: /* @__PURE__ */ a(vt, { as: Dt, allowPinchZoom: !0, children: /* @__PURE__ */ a(
          gt,
          {
            asChild: !0,
            trapped: m.open,
            onMountAutoFocus: (f) => {
              f.preventDefault();
            },
            onUnmountAutoFocus: N(l, (f) => {
              m.trigger?.focus({ preventScroll: !0 }), f.preventDefault();
            }),
            children: /* @__PURE__ */ a(
              ft,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: u,
                onPointerDownOutside: t,
                onFocusOutside: (f) => f.preventDefault(),
                onDismiss: () => m.onOpenChange(!1),
                children: /* @__PURE__ */ a(
                  ae,
                  {
                    role: "listbox",
                    id: m.contentId,
                    "data-state": m.open ? "open" : "closed",
                    dir: m.dir,
                    onContextMenu: (f) => f.preventDefault(),
                    ..._,
                    ...le,
                    onPlaced: () => W(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ..._.style
                    },
                    onKeyDown: N(_.onKeyDown, (f) => {
                      const T = f.ctrlKey || f.altKey || f.metaKey;
                      if (f.key === "Tab" && f.preventDefault(), !T && f.key.length === 1 && ce(f.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(f.key)) {
                        let C = F().filter((x) => !x.disabled).map((x) => x.ref.current);
                        if (["ArrowUp", "End"].includes(f.key) && (C = C.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(f.key)) {
                          const x = f.target, P = C.indexOf(x);
                          C = C.slice(P + 1);
                        }
                        setTimeout(() => E(C)), f.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ge.displayName = Ot;
var Lt = "SelectItemAlignedPosition", ze = o.forwardRef((r, c) => {
  const { __scopeSelect: e, onPlaced: i, ...l } = r, u = q(te, e), t = X(te, e), [n, s] = o.useState(null), [p, v] = o.useState(null), S = B(c, (R) => v(R)), b = pe(e), w = o.useRef(!1), I = o.useRef(!0), { viewport: d, selectedItem: h, selectedItemText: _, focusSelectedItem: m } = t, g = o.useCallback(() => {
    if (u.trigger && u.valueNode && n && p && d && h && _) {
      const R = u.trigger.getBoundingClientRect(), L = p.getBoundingClientRect(), z = u.valueNode.getBoundingClientRect(), Z = _.getBoundingClientRect();
      if (u.dir !== "rtl") {
        const x = Z.left - L.left, P = z.left - x, J = R.left - P, Q = R.width + J, ge = Math.max(Q, L.width), Se = window.innerWidth - D, we = Ne(P, [
          D,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(D, Se - ge)
        ]);
        n.style.minWidth = Q + "px", n.style.left = we + "px";
      } else {
        const x = L.right - Z.right, P = window.innerWidth - z.right - x, J = window.innerWidth - R.right - P, Q = R.width + J, ge = Math.max(Q, L.width), Se = window.innerWidth - D, we = Ne(P, [
          D,
          Math.max(D, Se - ge)
        ]);
        n.style.minWidth = Q + "px", n.style.right = we + "px";
      }
      const H = b(), F = window.innerHeight - D * 2, $ = d.scrollHeight, W = window.getComputedStyle(p), U = parseInt(W.borderTopWidth, 10), E = parseInt(W.paddingTop, 10), V = parseInt(W.borderBottomWidth, 10), K = parseInt(W.paddingBottom, 10), Y = U + E + $ + K + V, me = Math.min(h.offsetHeight * 5, Y), ce = window.getComputedStyle(d), he = parseInt(ce.paddingTop, 10), ve = parseInt(ce.paddingBottom, 10), oe = R.top + R.height / 2 - D, ae = F - oe, le = h.offsetHeight / 2, f = h.offsetTop + le, T = U + E + f, M = Y - T;
      if (T <= oe) {
        const x = H.length > 0 && h === H[H.length - 1].ref.current;
        n.style.bottom = "0px";
        const P = p.clientHeight - d.offsetTop - d.offsetHeight, J = Math.max(
          ae,
          le + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (x ? ve : 0) + P + V
        ), Q = T + J;
        n.style.height = Q + "px";
      } else {
        const x = H.length > 0 && h === H[0].ref.current;
        n.style.top = "0px";
        const J = Math.max(
          oe,
          U + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (x ? he : 0) + le
        ) + M;
        n.style.height = J + "px", d.scrollTop = T - oe + d.offsetTop;
      }
      n.style.margin = `${D}px 0`, n.style.minHeight = me + "px", n.style.maxHeight = F + "px", i?.(), requestAnimationFrame(() => w.current = !0);
    }
  }, [
    b,
    u.trigger,
    u.valueNode,
    n,
    p,
    d,
    h,
    _,
    u.dir,
    i
  ]);
  j(() => g(), [g]);
  const [G, O] = o.useState();
  j(() => {
    p && O(window.getComputedStyle(p).zIndex);
  }, [p]);
  const re = o.useCallback(
    (R) => {
      R && I.current === !0 && (g(), m?.(), I.current = !1);
    },
    [g, m]
  );
  return /* @__PURE__ */ a(
    Bt,
    {
      scope: e,
      contentWrapper: n,
      shouldExpandOnScrollRef: w,
      onScrollButtonChange: re,
      children: /* @__PURE__ */ a(
        "div",
        {
          ref: s,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: G
          },
          children: /* @__PURE__ */ a(
            A.div,
            {
              ...l,
              ref: S,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...l.style
              }
            }
          )
        }
      )
    }
  );
});
ze.displayName = Lt;
var Vt = "SelectPopperPosition", _e = o.forwardRef((r, c) => {
  const {
    __scopeSelect: e,
    align: i = "start",
    collisionPadding: l = D,
    ...u
  } = r, t = fe(e);
  return /* @__PURE__ */ a(
    _t,
    {
      ...t,
      ...u,
      ref: c,
      align: i,
      collisionPadding: l,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...u.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
_e.displayName = Vt;
var [Bt, Pe] = ne(te, {}), Ce = "SelectViewport", $e = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, nonce: i, ...l } = r, u = X(Ce, e), t = Pe(Ce, e), n = B(c, u.onViewportChange), s = o.useRef(0);
    return /* @__PURE__ */ k(Te, { children: [
      /* @__PURE__ */ a(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ a(ue.Slot, { scope: e, children: /* @__PURE__ */ a(
        A.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...l,
          ref: n,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...l.style
          },
          onScroll: N(l.onScroll, (p) => {
            const v = p.currentTarget, { contentWrapper: S, shouldExpandOnScrollRef: b } = t;
            if (b?.current && S) {
              const w = Math.abs(s.current - v.scrollTop);
              if (w > 0) {
                const I = window.innerHeight - D * 2, d = parseFloat(S.style.minHeight), h = parseFloat(S.style.height), _ = Math.max(d, h);
                if (_ < I) {
                  const m = _ + w, g = Math.min(I, m), G = m - g;
                  S.style.height = g + "px", S.style.bottom === "0px" && (v.scrollTop = G > 0 ? G : 0, S.style.justifyContent = "flex-end");
                }
              }
            }
            s.current = v.scrollTop;
          })
        }
      ) })
    ] });
  }
);
$e.displayName = Ce;
var Ye = "SelectGroup", [Ht, Ft] = ne(Ye), Wt = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, ...i } = r, l = be();
    return /* @__PURE__ */ a(Ht, { scope: e, id: l, children: /* @__PURE__ */ a(A.div, { role: "group", "aria-labelledby": l, ...i, ref: c }) });
  }
);
Wt.displayName = Ye;
var je = "SelectLabel", Ut = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, ...i } = r, l = Ft(je, e);
    return /* @__PURE__ */ a(A.div, { id: l.id, ...i, ref: c });
  }
);
Ut.displayName = je;
var de = "SelectItem", [Kt, qe] = ne(de), Xe = o.forwardRef(
  (r, c) => {
    const {
      __scopeSelect: e,
      value: i,
      disabled: l = !1,
      textValue: u,
      ...t
    } = r, n = q(de, e), s = X(de, e), p = n.value === i, [v, S] = o.useState(u ?? ""), [b, w] = o.useState(!1), I = B(
      c,
      (m) => s.itemRefCallback?.(m, i, l)
    ), d = be(), h = o.useRef("touch"), _ = () => {
      l || (n.onValueChange(i), n.onOpenChange(!1));
    };
    if (i === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ a(
      Kt,
      {
        scope: e,
        value: i,
        disabled: l,
        textId: d,
        isSelected: p,
        onItemTextChange: o.useCallback((m) => {
          S((g) => g || (m?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ a(
          ue.ItemSlot,
          {
            scope: e,
            value: i,
            disabled: l,
            textValue: v,
            children: /* @__PURE__ */ a(
              A.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": b ? "" : void 0,
                "aria-selected": p && b,
                "data-state": p ? "checked" : "unchecked",
                "aria-disabled": l || void 0,
                "data-disabled": l ? "" : void 0,
                tabIndex: l ? void 0 : -1,
                ...t,
                ref: I,
                onFocus: N(t.onFocus, () => w(!0)),
                onBlur: N(t.onBlur, () => w(!1)),
                onClick: N(t.onClick, () => {
                  h.current !== "mouse" && _();
                }),
                onPointerUp: N(t.onPointerUp, () => {
                  h.current === "mouse" && _();
                }),
                onPointerDown: N(t.onPointerDown, (m) => {
                  h.current = m.pointerType;
                }),
                onPointerMove: N(t.onPointerMove, (m) => {
                  h.current = m.pointerType, l ? s.onItemLeave?.() : h.current === "mouse" && m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(t.onPointerLeave, (m) => {
                  m.currentTarget === document.activeElement && s.onItemLeave?.();
                }),
                onKeyDown: N(t.onKeyDown, (m) => {
                  s.searchRef?.current !== "" && m.key === " " || (Pt.includes(m.key) && _(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Xe.displayName = de;
var se = "SelectItemText", Ze = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, className: i, style: l, ...u } = r, t = q(se, e), n = X(se, e), s = qe(se, e), p = Mt(se, e), [v, S] = o.useState(null), b = B(
      c,
      (_) => S(_),
      s.onItemTextChange,
      (_) => n.itemTextRefCallback?.(_, s.value, s.disabled)
    ), w = v?.textContent, I = o.useMemo(
      () => /* @__PURE__ */ a("option", { value: s.value, disabled: s.disabled, children: w }, s.value),
      [s.disabled, s.value, w]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: h } = p;
    return j(() => (d(I), () => h(I)), [d, h, I]), /* @__PURE__ */ k(Te, { children: [
      /* @__PURE__ */ a(A.span, { id: s.textId, ...u, ref: b }),
      s.isSelected && t.valueNode && !t.valueNodeHasChildren ? Ae.createPortal(u.children, t.valueNode) : null
    ] });
  }
);
Ze.displayName = se;
var Je = "SelectItemIndicator", Gt = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, ...i } = r;
    return qe(Je, e).isSelected ? /* @__PURE__ */ a(A.span, { "aria-hidden": !0, ...i, ref: c }) : null;
  }
);
Gt.displayName = Je;
var xe = "SelectScrollUpButton", zt = o.forwardRef((r, c) => {
  const e = X(xe, r.__scopeSelect), i = Pe(xe, r.__scopeSelect), [l, u] = o.useState(!1), t = B(c, i.onScrollButtonChange);
  return j(() => {
    if (e.viewport && e.isPositioned) {
      let n = function() {
        const p = s.scrollTop > 0;
        u(p);
      };
      const s = e.viewport;
      return n(), s.addEventListener("scroll", n), () => s.removeEventListener("scroll", n);
    }
  }, [e.viewport, e.isPositioned]), l ? /* @__PURE__ */ a(
    Qe,
    {
      ...r,
      ref: t,
      onAutoScroll: () => {
        const { viewport: n, selectedItem: s } = e;
        n && s && (n.scrollTop = n.scrollTop - s.offsetHeight);
      }
    }
  ) : null;
});
zt.displayName = xe;
var ye = "SelectScrollDownButton", $t = o.forwardRef((r, c) => {
  const e = X(ye, r.__scopeSelect), i = Pe(ye, r.__scopeSelect), [l, u] = o.useState(!1), t = B(c, i.onScrollButtonChange);
  return j(() => {
    if (e.viewport && e.isPositioned) {
      let n = function() {
        const p = s.scrollHeight - s.clientHeight, v = Math.ceil(s.scrollTop) < p;
        u(v);
      };
      const s = e.viewport;
      return n(), s.addEventListener("scroll", n), () => s.removeEventListener("scroll", n);
    }
  }, [e.viewport, e.isPositioned]), l ? /* @__PURE__ */ a(
    Qe,
    {
      ...r,
      ref: t,
      onAutoScroll: () => {
        const { viewport: n, selectedItem: s } = e;
        n && s && (n.scrollTop = n.scrollTop + s.offsetHeight);
      }
    }
  ) : null;
});
$t.displayName = ye;
var Qe = o.forwardRef((r, c) => {
  const { __scopeSelect: e, onAutoScroll: i, ...l } = r, u = X("SelectScrollButton", e), t = o.useRef(null), n = pe(e), s = o.useCallback(() => {
    t.current !== null && (window.clearInterval(t.current), t.current = null);
  }, []);
  return o.useEffect(() => () => s(), [s]), j(() => {
    n().find((v) => v.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [n]), /* @__PURE__ */ a(
    A.div,
    {
      "aria-hidden": !0,
      ...l,
      ref: c,
      style: { flexShrink: 0, ...l.style },
      onPointerDown: N(l.onPointerDown, () => {
        t.current === null && (t.current = window.setInterval(i, 50));
      }),
      onPointerMove: N(l.onPointerMove, () => {
        u.onItemLeave?.(), t.current === null && (t.current = window.setInterval(i, 50));
      }),
      onPointerLeave: N(l.onPointerLeave, () => {
        s();
      })
    }
  );
}), Yt = "SelectSeparator", jt = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, ...i } = r;
    return /* @__PURE__ */ a(A.div, { "aria-hidden": !0, ...i, ref: c });
  }
);
jt.displayName = Yt;
var Ie = "SelectArrow", qt = o.forwardRef(
  (r, c) => {
    const { __scopeSelect: e, ...i } = r, l = fe(e), u = q(Ie, e), t = X(Ie, e);
    return u.open && t.position === "popper" ? /* @__PURE__ */ a(Ct, { ...l, ...i, ref: c }) : null;
  }
);
qt.displayName = Ie;
var Xt = "SelectBubbleInput", et = o.forwardRef(
  ({ __scopeSelect: r, value: c, ...e }, i) => {
    const l = o.useRef(null), u = B(i, l), t = yt(c);
    return o.useEffect(() => {
      const n = l.current;
      if (!n) return;
      const s = window.HTMLSelectElement.prototype, v = Object.getOwnPropertyDescriptor(
        s,
        "value"
      ).set;
      if (t !== c && v) {
        const S = new Event("change", { bubbles: !0 });
        v.call(n, c), n.dispatchEvent(S);
      }
    }, [t, c]), /* @__PURE__ */ a(
      A.select,
      {
        ...e,
        style: { ...It, ...e.style },
        ref: u,
        defaultValue: c
      }
    );
  }
);
et.displayName = Xt;
function tt(r) {
  return r === "" || r === void 0;
}
function ot(r) {
  const c = xt(r), e = o.useRef(""), i = o.useRef(0), l = o.useCallback(
    (t) => {
      const n = e.current + t;
      c(n), function s(p) {
        e.current = p, window.clearTimeout(i.current), p !== "" && (i.current = window.setTimeout(() => s(""), 1e3));
      }(n);
    },
    [c]
  ), u = o.useCallback(() => {
    e.current = "", window.clearTimeout(i.current);
  }, []);
  return o.useEffect(() => () => window.clearTimeout(i.current), []), [e, l, u];
}
function nt(r, c, e) {
  const l = c.length > 1 && Array.from(c).every((p) => p === c[0]) ? c[0] : c, u = e ? r.indexOf(e) : -1;
  let t = Zt(r, Math.max(u, 0));
  l.length === 1 && (t = t.filter((p) => p !== e));
  const s = t.find(
    (p) => p.textValue.toLowerCase().startsWith(l.toLowerCase())
  );
  return s !== e ? s : void 0;
}
function Zt(r, c) {
  return r.map((e, i) => r[(c + i) % r.length]);
}
var Jt = De, Qt = Ve, eo = He, to = Fe, oo = We, no = Ue, ro = $e, Me = Xe, ke = Ze;
const lo = "_disabled_rdskl_50", so = "_value_rdskl_118", y = {
  "select-container": "_select-container_rdskl_29",
  "is-full-width": "_is-full-width_rdskl_34",
  "group-label": "_group-label_rdskl_37",
  "is-error": "_is-error_rdskl_47",
  disabled: lo,
  "optional-label": "_optional-label_rdskl_53",
  "label-helper-text": "_label-helper-text_rdskl_57",
  "select-trigger": "_select-trigger_rdskl_61",
  "select-full-width": "_select-full-width_rdskl_77",
  value: so,
  "select-icon": "_select-icon_rdskl_121",
  "select-content": "_select-content_rdskl_133",
  "select-viewport": "_select-viewport_rdskl_146",
  "select-item": "_select-item_rdskl_150",
  "select-placeholder": "_select-placeholder_rdskl_151",
  "container-icon": "_container-icon_rdskl_178",
  "scroll-area-root": "_scroll-area-root_rdskl_195",
  "scroll-area-viewport": "_scroll-area-viewport_rdskl_200",
  "scroll-area-scrollbar": "_scroll-area-scrollbar_rdskl_205",
  "scroll-area-thumb": "_scroll-area-thumb_rdskl_210",
  "dialog-overlay-show": "_dialog-overlay-show_rdskl_1",
  "dialog-content-show": "_dialog-content-show_rdskl_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_rdskl_1"
}, Lo = ({
  onChange: r,
  value: c,
  items: e,
  placeholder: i,
  label: l,
  labelHelperContent: u,
  status: t,
  disabled: n,
  message: s,
  ariaLabel: p,
  optionalMessage: v,
  isFullWidth: S = !1
}) => {
  const b = ie(y["select-container"], {
    [y["is-full-width"]]: S
  });
  return /* @__PURE__ */ k("div", { className: b, children: [
    /* @__PURE__ */ k(Tt, { direction: "column", gap: "2", isFullWidth: !0, children: [
      l && /* @__PURE__ */ k("div", { className: y["group-label"], children: [
        /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ a("label", { className: ie(t && y[`is-${t}`], n && y.disabled), children: l }),
          v && /* @__PURE__ */ a("span", { className: y["optional-label"], children: v })
        ] }),
        u && /* @__PURE__ */ a("div", { className: y["label-helper-text"], children: u })
      ] }),
      /* @__PURE__ */ k(Jt, { disabled: n, value: c ?? "", onValueChange: r, children: [
        /* @__PURE__ */ k(
          Qt,
          {
            className: ie(
              t && !n && y[`is-${t}`],
              y["select-trigger"],
              S && y["select-full-width"]
            ),
            "aria-label": p ?? l,
            children: [
              /* @__PURE__ */ a(eo, { className: y.value, placeholder: i }),
              /* @__PURE__ */ a(to, { className: y["select-icon"], children: /* @__PURE__ */ a(Ee, { size: "small", name: "up-arrow" }) })
            ]
          }
        ),
        /* @__PURE__ */ a(oo, { children: /* @__PURE__ */ a(no, { className: y["select-content"], position: "popper", children: /* @__PURE__ */ k(rt, { className: y["scroll-area-root"], type: "auto", children: [
          /* @__PURE__ */ a(ro, { className: y["select-viewport"], asChild: !0, children: /* @__PURE__ */ k(lt, { className: y["scroll-area-viewport"], children: [
            i && /* @__PURE__ */ a(Me, { className: y["select-placeholder"], value: "header", disabled: !0, children: /* @__PURE__ */ a(ke, { children: i }) }),
            e.map((w) => /* @__PURE__ */ a(
              Me,
              {
                className: y["select-item"],
                value: w.value,
                disabled: w.disabled,
                children: /* @__PURE__ */ a(ke, { children: w.displayedValue || w.value })
              },
              w.id
            ))
          ] }) }),
          /* @__PURE__ */ a(st, { className: y["scroll-area-scrollbar"], orientation: "vertical", children: /* @__PURE__ */ a(ct, { className: y["scroll-area-thumb"] }) })
        ] }) }) })
      ] })
    ] }),
    s && t && !n && /* @__PURE__ */ k("div", { className: ie(t && y[`is-${t}`], y["container-icon"]), children: [
      /* @__PURE__ */ a(Ee, { name: "error-warning-fill", size: "medium" }),
      /* @__PURE__ */ a("span", { children: s })
    ] })
  ] });
};
export {
  Lo as SelectField
};
